import React from 'react';
import classNames from 'classnames';
import classes from './button.scss';
const Button = props => {
  const {
    onClick,
    children,
    type,
    size,
    disabled = false,
    loading = false,
    className,
    name = '',
    style,
    formType,
    dataButton
  } = props;
  let buttonType;
  switch (type) {
    case 'primary':
    case 'secondary':
    case 'transparent':
    case 'default':
      buttonType = classes[type];
      break;
    default:
      buttonType = classes.defaultBtn;
      break;
  }
  let buttonSize;
  switch (size) {
    case 'large':
    case 'normal':
    case 'small':
      buttonSize = classes[size];
      break;
    default:
      buttonSize = classes.normal;
      break;
  }
  const buttonClasses = classNames(classes.button, buttonType, buttonSize, {
    [classes.disabled]: disabled
  }, className);
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: buttonClasses,
    disabled: disabled,
    name: name,
    style: style,
    type: formType,
    "data-button": dataButton
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [classes.visible]: !loading
    })
  }, children));
};
export default Button;